var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music/close/circle",
    clipPath: "url(#clip0_969_10117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.0003 10.5001L8.00033 8.50008M8.00033 8.50008L6.00033 6.50008M8.00033 8.50008L6.00033 10.5001M8.00033 8.50008L10.0003 6.50008M0.666992 8.50008C0.666992 12.5502 3.95024 15.8334 8.00033 15.8334C12.0504 15.8334 15.3337 12.5502 15.3337 8.50008C15.3337 4.44999 12.0504 1.16675 8.00033 1.16675C3.95024 1.16675 0.666992 4.44999 0.666992 8.50008Z",
    stroke: "#979AA0",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_10117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle_close.0c5fcb6ac972bdaf794a4b02a3bf72be.svg";
export { ForwardRef as ReactComponent };